import React from 'react';

import { Box } from '../../../components/MuiGenerals';

const FilterTopActionRow = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '1rem',
        marginBottom: '1rem',
      }}
    >
      {children}
    </Box>
  );
};

export default FilterTopActionRow;
